<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="buttonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>
                Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="reprintSaleDetail('printSaleSummary')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-layout row wrap>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              ref="menu"
              v-model="fromTime"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="time"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="queryParams.fromTime"
                  label="From Time"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="fromTime"
                format="24hr"
                v-model="queryParams.fromTime"
                full-width
                @click:minute="$refs.menu.save(queryParams.fromTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-menu
              ref="menu1"
              v-model="toTime"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="time"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="queryParams.toTime"
                  label="To Time"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="toTime"
                format="24hr"
                v-model="queryParams.toTime"
                full-width
                @click:minute="$refs.menu1.save(queryParams.toTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3>
            <v-text-field name="saleNo" label="Sale No" v-model="queryParams.saleNo" type="text"></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="wayAssignNo"
              label="Way Assign No"
              v-model="queryParams.wayAssignNo"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="shopList"
              label="Choose Shop..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              v-model="queryParams.shopId"
              @change="getCountersByShopId(queryParams.shopId)"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="customerShopList"
              label="Choose Customer Shop..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.customerShopId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="payTypes"
              label="PayType"
              item-text="label"
              item-value="value"
              v-model="queryParams.payType"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="marketingList"
              label="Marketing"
              item-text="username"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.cashierId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="regionList"
              label="Choose Region"
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.regionId"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Tax:</span>
              <v-chip>
                <span>{{ totalTaxAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Sale Amount:</span>
              <v-chip>
                <span>{{ totalAmount | decFormat(6)}}</span>
              </v-chip>

              <span>Total Return Amount:</span>
              <v-chip>
                <span>{{ totalReturnAmount | decFormat(6)}}</span>
              </v-chip>

              <span>Total Discount Amount:</span>
              <v-chip>
                <span>{{ totalDiscountAmount | decFormat(6)}}</span>
              </v-chip>

              <!-- <span>Total Net Amount:</span>
              <v-chip>
                <span>{{ totalAmount-totalReturnAmount-totalDiscountAmount | decFormat(6)}}</span>
              </v-chip>-->

              <span>Total Net Amount:</span>
              <v-chip>
                <span>{{ totalNetAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Expense Amount:</span>
              <v-chip>
                <span>{{ totalExpenseAmount | decFormat(6)}}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="summaryHeaders"
            :items="saleSummaryList"
            :rows-per-page-items="rowsPerPageItems2"
            :pagination.sync="pagination2"
            expand
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.caisherName }}</td>
              <td>{{ props.item.regionName }}</td>
              <td>{{ props.item.payType }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td style="text-align: right">{{ props.item.amount | decFormat(6)}}</td>
              <td style="text-align: right">{{ props.item.taxAmount | decFormat(6)}}</td>
              <td style="text-align: right">{{ props.item.discountAmount | decFormat(6)}}</td>
              <td style="text-align: right">{{ props.item.netAmount | decFormat(6)}}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="saleReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.saleNo }}</td>
                <td>{{ props.item.wayAssignNo }}</td>
                <td>{{ props.item.shopName }}</td>
                <td>{{ props.item.customerShopName }}</td>
                <td>{{ props.item.regionName }}</td>
                <td>{{ props.item.createdBy }}</td>
                <td>{{ props.item.payType}}</td>
                <td v-if="props.item.customer">{{ props.item.customer.creditLevel.periodDays }}</td>
                <td v-else>-</td>
                <td>{{ props.item.currencyCode }}</td>
                <td>{{ props.item.priceModelName }}</td>
                <td style="text-align: right">{{ props.item.totalAmount | decFormat(6) }}</td>
                <td style="text-align: right">{{ props.item.taxAmount | decFormat(6) }}</td>
                <td style="text-align: right">{{ props.item.discountAmount | decFormat(6)}}</td>
                <td style="text-align: right">{{ props.item.netAmount | decFormat(6)}}</td>
                <td style="text-align: right">{{ props.item.receivedAmount | decFormat(6) }}</td>
                <td style="text-align: right">{{ props.item.payChange | decFormat(6) }}</td>
                <td style="text-align: right">{{ props.item.totalReturnAmount | decFormat(6) }}</td>
                <td class="text-xs">
                  <v-icon
                    center
                    color="success"
                    v-if="props.item.isAdvancedAmount == true"
                  >check_circle</v-icon>
                </td>
                <td class="text-xs">
                  <v-icon
                    center
                    color="success"
                    v-if="props.item.isItemDiscount == true"
                  >check_circle</v-icon>
                </td>
                <td>
                  <v-btn color="primary" @click.stop="reprint(props.item)">REPRINT</v-btn>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.saleItems"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.product.name }}</td>
                      <td class="text-xs">
                        <v-icon
                          center
                          color="success"
                          v-if="subprops.item.isFOC == true"
                        >check_circle</v-icon>
                      </td>
                      <td class="text-xs">
                        <v-icon
                          center
                          color="success"
                          v-if="subprops.item.isExchange == true"
                        >check_circle</v-icon>
                      </td>
                      <td class="text-xs">
                        <v-icon
                          center
                          color="success"
                          v-if="subprops.item.isReturn == true"
                        >check_circle</v-icon>
                      </td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.productUnit.factor+"/"+subprops.item.productUnit.unitName}}</td>
                      <td class="text-xs">{{ subprops.item.unitPrice | decFormat(6) }}</td>
                      <td class="text-xs">{{ subprops.item.discountPercent + "%" }}</td>
                      <td class="text-xs">{{ subprops.item.qty | decFormat(6) }}</td>
                      <td
                        class="text-xs"
                      >{{ ((subprops.item.unitPrice) - ((subprops.item.unitPrice) * (subprops.item.discountPercent / 100))) * subprops.item.qty | decFormat(6) }}</td>
                      <td class="text-xs">{{ subprops.item.returnQty | decFormat(6) }}</td>
                      <td
                        class="text-xs"
                      >{{ subprops.item.unitPrice * subprops.item.returnQty | decFormat(6) }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
        <!-- </v-expansion-panel> -->
      </v-flex>
    </v-layout>
    <!-- reprint sale slip hidden area -->
    <div
      style="font-size: 13px!important"
      v-show="false"
      v-for="(sale,index) in saleReportList"
      :key="index"
      :id="`printSaleDetail${sale.id}`"
      :data="sale"
    >
      <div style="bsale:1px solid black;width:300px;">
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopName}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shop.address}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Tel: {{sale.shop.phoneNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Invoice #: {{sale.saleNo}}</p>
        </div>
        <div style="text-align:center">
          <p
            style="font-size:11px;margin:0px"
            id="date"
          >{{ sale.createdDateInMilliSeconds | format-ms-custom-date }}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;font-weight:bold;margin:0px">REPRINT</p>
        </div>
        <div style="float:left;padding-left:11px">
          <p style="font-size:11px;margin:0px" id="counter">Counter: {{sale.counterName}}</p>
        </div>
        <div style="float:right;padding-right:11px">
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.createdBy}}</p>
        </div>
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left"></th>
                <th style="text-align:center">Unit</th>
                <th style="text-align:center">Qty</th>
                <th style="text-align:right">Price</th>
                <th style="text-align:right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.notFocItems" :key="index">
                <td style="text-align:left">{{item.product.name}}</td>
                <td style="text-align:center">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center">{{item.qty | decFormat(6) }}</td>
                <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
                <td style="text-align:right">{{item.qty * item.unitPrice| decFormat(6)}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
          >
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.totalAmount | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Tax ({{sale.taxType}})</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.taxAmount | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
                v-if="sale.discountAmount > 0"
              >{{sale.discountAmount | decFormat(6)}}</td>
              <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Received</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount + sale.payChange | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Pay Change</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.payChange | decFormat(6)}}</td>
            </tr>
          </table>
        </div>
        <!-- FOC Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.focItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left">FOC Items</th>
                <th style="text-align:center">Unit</th>
                <th style="text-align:center">Qty</th>
                <th style="text-align:right">Price</th>
                <th style="text-align:right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.focItems" :key="index">
                <td style="text-align:left">{{item.product.name}}</td>
                <td style="text-align:center">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center">{{item.qty | decFormat(6) }}</td>
                <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
                <td
                  style="text-align:right"
                >{{item.qty * item.unitPrice | decFormat(6)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Return Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.returnItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left">Return Items</th>
                <th style="text-align:center">Unit</th>
                <th style="text-align:center">Qty</th>
                <th style="text-align:right">Price</th>
                <th style="text-align:right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.returnItems" :key="index">
                <td style="text-align:left">{{item.product.name}}</td>
                <td style="text-align:center">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center">{{item.returnQty | decFormat(6) }}</td>
                <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
                <td
                  style="text-align:right"
                >{{item.returnQty * item.unitPrice | decFormat(6)}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
        </div>
        <div style="height:5px;"></div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Thank You! Please Come Again.</p>
        </div>
      </div>
    </div>
    <!-- <summary report> -->
    <div id="printSaleSummary" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Sale Summary</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Tax: {{totalTaxAmount | decFormat(6)}}</p>
      </div>
      <div style="text-align:left">
        <p
          style="font-size:15px;margin:0px"
        >Total Amount: {{totalAmount | decFormat(6)}}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Shop Name</th>
              <th style="text-align:left">Marketing</th>
              <th style="text-align:left">Region</th>
              <th style="text-align:left">Pay Type</th>
              <th style="text-align:left">Currency</th>
              <th style="text-align:left">Total Amount</th>
              <th style="text-align:left">Total Tax Amount</th>
              <th style="text-align:left">Discount Amount</th>
              <th style="text-align:left">Total Net Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in saleReportSummaryList" :key="index">
              <td>{{ item.shopName }}</td>
              <td>{{ item.caisherName }}</td>
              <td>{{ item.regionName }}</td>
              <td>{{ item.payType }}</td>
              <td>{{ item.currencyCode }}</td>
              <td>{{ item.amount | decFormat(6)}}</td>
              <td>{{ item.taxAmount | decFormat(6)}}</td>
              <td>{{ item.discountAmount | decFormat(6)}}</td>
              <td>{{ item.netAmount | decFormat(6)}}</td>
            </tr>
          </tbody>
        </table>
        <div style="height:10px"></div>
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Sale Date</th>
              <th style="text-align:left">Sale No</th>
              <th style="text-align:left">Way Assign No</th>
              <th style="text-align:left">Customer Shop</th>
              <th style="text-align:left">Marketing</th>
              <th style="text-align:left">Region</th>
              <th style="text-align:left">Pay Type</th>
              <th style="text-align:left">Currency</th>
              <th style="text-align:left">Price Model</th>
              <th style="text-align:left">Discount Amount</th>
              <th style="text-align:left">Tax mount</th>
              <th style="text-align:left">Net Amount</th>
              <th style="text-align:left">Received</th>
              <th style="text-align:left">Pay Change</th>
              <th style="text-align:left">Item %</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allSaleReportList" :key="index">
              <td style="text-align:left">{{item.createdDateInMilliSeconds | format-ms-date}}</td>
              <td style="text-align:left">{{item.saleNo}}</td>
              <td style="text-align:left">{{item.wayAssignNo}}</td>
              <td style="text-align:left">{{item.customerShopName}}</td>
              <td style="text-align:left">{{item.createdBy}}</td>
              <td style="text-align:left">{{ item.regionName }}</td>
              <td style="text-align:left">{{item.payType}}</td>
              <td style="text-align:left">{{item.currencyCode}}</td>
              <td style="text-align:left">{{item.priceModelName }}</td>
              <td style="text-align:left">{{item.discountAmount | decFormat(6)}}</td>
              <td style="text-align:left">{{item.taxAmount | decFormat(6)}}</td>
              <td style="text-align:left">{{item.netAmount | decFormat(6)}}</td>
              <td
                style="text-align:left"
              >{{item.netAmount+item.payChange | decFormat(6)}}</td>
              <td style="text-align:left">{{item.payChange | decFormat(6)}}</td>
              <td style="text-align:left" v-if="item.isItemDiscount == true">Yes</td>
              <td style="text-align:left" v-else>No</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { saleReportService } from "../../services/sale-report-service";
import { shopService } from "../../services/shop-service";
import { customerShopService } from "../../services/customer-shop-service";
import { counterService } from "../../services/counter-service";
import { saleService } from "../../services/sale-service";
import { userService } from "../../services/user-service";
import { regionService } from "../../services/region-service";
import { Sale } from "../../models/model";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "WaySaleReportList",

  components: { Loading },
  data: () => ({
    time: false,
    fromTime: false,
    toTime: false,
    showListLoading: false,
    dialog: false,
    show: false,
    showFilters: false,
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "General Reports",
        disabled: true
      },
      {
        text: "Way Sale Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Sale Date ", align: "left", value: "created_date" },
      { text: "Sale No", value: "sale_no" },
      { text: "Way Assign No", value: "way_assign_no" },
      { text: "Shop", value: "sh.name" },
      { text: "Customer Shop", value: "csh.name" },
      { text: "Region", value: "region", sortable: false },
      { text: "Marketing", value: "created_by" },
      { text: "Pay Type", value: "pay_type" },
      {
        text: "Period Days",
        align: "center",
        value: "period_days",
        sortable: false
      },
      { text: "Currency", value: "currencyCode" },
      { text: "Price Model", value: "priceModelName" },
      { text: "Total Amount", value: "total_amount" },
      { text: "Tax", value: "tax_amount" },
      { text: "Discount", value: "discount_amount" },
      { text: "Net Amount", value: "net_amount" },
      { text: "Received", sortable: false },
      { text: "Pay Change", value: "pay_change" },
      { text: "Total Return Amount", value: "total_return_amount" },
      { text: "Advanced", value: "isAdvancedAmount", sortable: false },
      { text: "Item %", sortable: false },
      { text: "Reprint", align: "center", sortable: false }
    ],
    subHeaders: [
      { text: "Product Name", sortable: false },
      { text: "FOC", sortable: false },
      { text: "Exchange", sortable: false },
      { text: "Return", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Unit Price", sortable: false },
      { text: "Item %", sortable: false },
      { text: "Qty", sortable: false },
      { text: "Total Amount", sortable: false },
      { text: "Return Qty", sortable: false },
      { text: "Total Return Amount", sortable: false }
    ],
    summaryHeaders: [
      { text: "Shop", align: "left", value: "shopName" },
      { text: "Marketing", align: "left", value: "cashierName" },
      { text: "Region", align: "left", value: "regionName" },
      { text: "Cash Type", align: "left", value: "cashType" },
      { text: "Currency", align: "left", value: "currencyCode" },
      { text: "Total Amount", value: "totalAmount" },
      { text: "Total Tax Amount", value: "totalTaxAmount" },
      { text: "Total Discount Amount", value: "totalDiscountAmount" },
      { text: "Total Net Amount", value: "totalNetAmount" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "created_date",
      totalItems: 0
    },
    rowsPerPageItems2: [25, 50, 100],
    pagination2: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0
    },
    decimalFormat: "",
    regionList: [],
    shopList: [],
    counterList: [],
    saleReportList: [],
    saleReportSummaryList: [],
    allSaleReportList: [],
    saleSummaryList: [],
    saleDetailList: [],
    marketingList: [],
    customerShopList: [],
    sale: new Sale(),
    totalAmount: 0,
    totalNetAmount: 0,
    totalExpenseAmount: 0,
    totalDiscountAmount: 0,
    totalTaxAmount: 0,
    totalReturnAmount: 0,
    saleNo: 0,
    wayAssignNo: "",
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      fromTime: "00:00",
      toTime: "23:59",
      saleNo: "",
      wayAssignNo: "",
      counterId: "",
      shopId: "",
      userName: "",
      payType: "",
      cashierId: "",
      customerShopId: "",
      regionId: ""
    },
    clonequeryParams: new Object(),
    buttonLoading: false,
    isLoading: false,
    payTypes: [
      { label: "----All----", value: "" },
      { label: "CASH", value: "CASH" },
      { label: "CREDIT", value: "CREDIT" }
    ],
    fullPage: true
  }),
  watch: {
    pagination: {
      handler() {
        this.getWaySaleSummaryList();
        this.getWaySaleReportList();
      },
      deep: true
    }
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    //  if (user.role.roleName == "ADMIN") {
    this.getAllShop();
    this.getAllCustomerShop();
    this.getAllRegion();
    // }
    //if (user.role.roleName != "ADMIN") {
    this.queryParams.shopId = user.shopId;
    //}
    // if (user.shopId) {
    //  this.getCountersByShopId(user.shopId);
    //}
    if (user.role.roleName == "SALE") {
      this.queryParams.userName = user.username;
    }
    this.onSearch();
    //for deep linking
    if (this.$route.query.regionId) {
      this.queryParams.regionId = this.$route.query.regionId;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.counterId) {
      this.queryParams.counterId = this.$route.query.counterId;
    }
    if (this.$route.query.saleNo) {
      this.queryParams.saleNo = this.$route.query.saleNo;
    }
    if (this.$route.query.wayAssignNo) {
      this.queryParams.WayAssignNo = this.$route.query.wayAssignNo;
    }
    if (this.$route.query.userName) {
      this.queryParams.userName = this.$route.query.userName;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.fromTime) {
      this.queryParams.fromTime = this.$route.query.fromTime;
    }
    if (this.$route.query.toTime) {
      this.queryParams.toTime = this.$route.query.toTime;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.$route.query.customerShopId) {
      this.pagination.customerShopId = this.$route.query.customerShopId;
    }
    this.getAllCashier();
    this.decimalFormat = commonService.formatdecimal();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "way-sale-report",
        query: this.queryParams
      });
      this.getWaySaleSummaryList();
      this.getWaySaleReportList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
      console.log(this.queryParams);
      console.log(this.clonequeryParams);
    },
    getWaySaleReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleReportService
        .getWaySaleReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.saleReportList = res.data.saleList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getAllRegion() {
      regionService
        .getAllRegions()
        .then(res => {
          this.regionList = res.data;
          let findAll = {
            id: "",
            name: "----No Region----"
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getAllCustomerShop() {
      customerShopService
        .getAll()
        .then(res => {
          this.customerShopList = res.data.customerShopList;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.customerShopList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getWaySaleSummaryList() {
      saleReportService
        .getWaySaleSummaryList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.saleSummaryList = res.data.saleSummaryList;
            this.totalAmount = res.data.totalAmount;
            this.totalNetAmount = res.data.totalNetAmount;
            this.totalDiscountAmount = res.data.totalDiscountAmount;
            this.totalTaxAmount = res.data.totalTaxAmount;
            this.totalReturnAmount = res.data.totalReturnAmount;
            this.totalExpenseAmount = res.data.totalExpenseAmount;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },

    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getAllCashier() {
      userService
        .getAllMarketing()
        .then(res => {
          this.marketingList = res.data;
          let findAll = {
            id: "",
            username: "---All---"
          };
          this.marketingList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.responseError.data.message;
          }
        });
    },

    getCountersByShopId(shopId) {
      counterService
        .getCountersByShopId(shopId)
        .then(res => {
          this.counterList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.counterList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    reprint(sale) {
      this.isLoading = true;
      this.printDirectSaleInvoiceById(sale.id);
    },

    printDirectSaleInvoiceById(id) {
      saleService
        .printDirectSaleInvoiceById(id)
        .then(res => {
          var blob = res;
          saleService.showWindowDialog(blob, "DirectSaleInvoice-" + id);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reprintSaleDetail(divName) {
      this.buttonLoading = true;
      saleReportService
        .getAllWaySaleReportList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allSaleReportList = res.data.saleList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          saleReportService
            .getWaySaleSummaryList(this.clonequeryParams)
            .then(res => {
              if (res.data) {
                this.saleReportSummaryList = res.data.saleSummaryList;
              }
            })
            .catch(err => {
              console.log(err);
            })
            .finally(() => {
              var printContents = document.getElementById(divName).innerHTML;
              var reprintWindow = window.open(
                "",
                "MsgWindow",
                "width=500,height=500"
              );
              reprintWindow.document.write(printContents);
              setTimeout(() => {
                reprintWindow.print();
                reprintWindow.close();
              }, 600);
              this.buttonLoading = false;
            });
        });
    },
    clear() {
      this.queryParams.data = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.queryParams.fromTime = "00:00";
      this.queryParams.toTime = "23:59";
    }
  }
};
</script>
